export default __webpack_public_path__ + "static/media/error.7568cf92.png";